import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { AgendamentoSolicitacaoItem } from '@/types/_'

@Module({ namespaced: true, name: 'BackofficeDataAgendamentoStore' })
export default class BackofficeDataAgendamentoStore extends VuexModule {
  modal: any = {
    confirmarDataAgendamento: false,
  }

  private agendamentoItemDefault: AgendamentoSolicitacaoItem = {
    acoes: {
      agendamentoAtualizaTriagem: false,
      agendamentoConfirmaCancelamento: false,
      agendamentoFazCancelamento: false,
      agendamentoRealizaTriagem: false,
      alterarData: false,
      analizarResposta: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoAlteraSolicitacaoAutorizada: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoResolvePendenciaRoboAutorizacao: false,
      autorizacaoFazRetornoParaCotacao: false,
      autorizacaoSolicitaCancelamento: false,
      confirmarData: false,
      contatar: false,
      visualizar: false,
      visualizarPendencia: false,
      agendamentoFazConsultaDePrecaucoesDoPaciente: false,
    },
    carater: { key: '', display: '' },
    convenioId: '',
    convenioNome: '',
    dataAgendamento: '',
    dataAgendamentoVirtual: false,
    dataNascimento: '',
    dataProximoContato: '',
    dataSolicitacao: '',
    etapa: {
      display: '',
      key: '',
    },
    hospitalId: '',
    hospitalNome: '',
    id: '',
    lembreteStatus: '',
    medicoId: '',
    medicoNome: '',
    numeroAgendamento: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opme: '',
    pacienteNome: '',
    procedimentoPrincipalNome: '',
    situacao: {
      display: '',
      key: '',
      quantidade: 0,
    },
    situacaoData: '',
    statusSla: {
      status: '',
      tempo: {
        dias: 0,
        horas: 0,
        minutos: 0,
        segundos: 0,
        totalDias: 0,
        totalHoras: 0,
        totalMinutos: 0,
      },
    },
    tempoNoStatus: '',
    opcao: '',
    auditada: false,
    autorizacaoValidade: '',
  }

  agendamentoItem: AgendamentoSolicitacaoItem = { ...this.agendamentoItemDefault }

  @Mutation
  setAgendamentoItem(agendamentoItem: AgendamentoSolicitacaoItem) {
    const temp: AgendamentoSolicitacaoItem = agendamentoItem
    if (!agendamentoItem.opcao) {
      temp.opcao = ''
    }

    this.agendamentoItem = temp
  }

  @Mutation
  clearAgendamentoItem() {
    this.agendamentoItem = { ...this.agendamentoItemDefault }
  }

  @Mutation
  setModal(modal: any) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  clearDataAgendamentoOpcao() {
    this.agendamentoItem.opcao = ''
  }
}
